// Tutaj ustawiam sobie ścieżkę do API CloudPanelu
const domain = window.location.host.split('.');
const tld = domain[domain.length - 1];


if (tld === 'test' || tld === 'dev') {
    // Jeśli domena jest z końcówką .test lub .dev to ustawiam endpoint na lokalny
    window.cloudpanelapi = 'https://cp-v2.test/api';
} else {
    // w przeciwnym wypadku używam produkcyjnego
    window.cloudpanelapi = 'https://cloudpanel.pl/api';
}
